import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { FileEdit } from "lucide-react";

interface Item { id: string; title: string; slug: string; status: string; updated_at: string; published_at: string | null; }

const DraftList = ({ filter, onOpen }: { filter: "draft" | "published" | "all"; onOpen: (id: string) => void }) => {
  const [items, setItems] = useState<Item[]>([]);
  const load = async () => {
    let q = (supabase as any).from("blog_articles").select("id,title,slug,status,updated_at,published_at").order("updated_at", { ascending: false });
    if (filter !== "all") q = q.eq("status", filter);
    const { data } = await q;
    setItems(data || []);
  };
  useEffect(() => { load(); }, [filter]);

  return (
    <Card>
      <CardHeader>
        <CardTitle className="font-heading flex items-center gap-2">
          <FileEdit className="h-5 w-5 text-primary" />
          {filter === "draft" ? "Brouillons en attente d'audit" : filter === "published" ? "Articles publiés" : "Tous les articles"}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {items.length === 0 ? (
          <p className="text-sm text-muted-foreground">Aucun article.</p>
        ) : (
          <div className="space-y-2">
            {items.map((it) => (
              <button key={it.id} onClick={() => onOpen(it.id)} className="w-full text-left rounded-lg border border-border p-3 hover:bg-accent transition flex items-center justify-between gap-3">
                <div className="min-w-0 flex-1">
                  <div className="font-medium truncate">{it.title || it.slug}</div>
                  <div className="text-xs text-muted-foreground truncate">/{it.slug}</div>
                  <div className="text-[11px] text-muted-foreground mt-0.5 flex flex-wrap gap-x-3">
                    {it.published_at && <span>📅 Publié&nbsp;: {new Date(it.published_at).toLocaleDateString("fr-FR")}</span>}
                    <span>✏️ Modifié&nbsp;: {new Date(it.updated_at).toLocaleString("fr-FR")}</span>
                  </div>
                </div>
                <Badge variant={it.status === "published" ? "default" : "secondary"}>{it.status === "published" ? "Publié" : "Brouillon"}</Badge>
              </button>
            ))}
          </div>
        )}
        <Button variant="outline" onClick={load} size="sm" className="mt-3">Actualiser</Button>
      </CardContent>
    </Card>
  );
};

export default DraftList;